import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback, useMemo } from 'react';
import { IconsLibrary } from './icon';
import { MaterialBoolControl } from '.';
import { web_element_icons } from './icon/icons';
import { SettingFullRow } from 'console/device-settings/z3k/components/material-utils/settings-card';
export const IconWithHiddenNameSensor = memo(function UISensor(props) {
    const { device_ui_settings, item, replace_device_ui_settings } = props;
    const web_element_icon = useMemo(() => device_ui_settings?.icons?.web_elements?.[item.id], [device_ui_settings?.icons?.web_elements, item.id]);
    const onChangeWebElementIcon = useCallback((icon_id) => {
        if ((typeof icon_id === 'number' && icon_id > 0) ||
            typeof icon_id === 'string') {
            const new_ui_settings = {
                ...device_ui_settings,
                icons: {
                    ...device_ui_settings?.icons,
                    web_elements: {
                        ...(device_ui_settings?.icons?.web_elements ?? {}),
                        [item.id]: icon_id,
                    },
                },
            };
            replace_device_ui_settings(new_ui_settings);
        }
        else {
            const null_ui_settings = {
                ...device_ui_settings,
                icons: {
                    ...device_ui_settings?.icons,
                    web_elements: {
                        ...(device_ui_settings?.icons?.web_elements ?? {}),
                        [item.id]: null,
                    },
                },
            };
            replace_device_ui_settings(null_ui_settings);
        }
    }, [device_ui_settings, item.id]);
    const checked = useMemo(() => device_ui_settings?.hidden_name?.[item.id], [device_ui_settings?.hidden_name, item.id]);
    const onRegister = useCallback((checked) => {
        const new_ui_settings = {
            ...device_ui_settings,
            hidden_name: {
                ...(device_ui_settings?.hidden_name ?? {}),
                [item.id]: checked,
            },
        };
        replace_device_ui_settings(new_ui_settings);
    }, [device_ui_settings, item.id]);
    return (_jsxs(SettingFullRow, { alignContent: "center", children: [_jsx(IconsLibrary, { value: web_element_icon || 0, onChange: onChangeWebElementIcon, icons: web_element_icons }), web_element_icon != null && (_jsx(MaterialBoolControl, { label: "\u0421\u043A\u0440\u044B\u0432\u0430\u0442\u044C \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435", value: checked !== undefined && checked, onChange: onRegister, help_id: "icons_hidden_name" }))] }));
});
